const deerCategories = {
  "Appliances": 1,
  "BAS": 2,
  "Envelope": 3,
  "HVAC": 4,
  "Lighting": 5,
  "Water Heating": 6,
  "Energy Generation": 7,
};

const deerSubCategories = {
  "High-efficiency Appliances": 1,
  "Building Energy Management System": 2,
  "Infiltration Reduction": 3,
  "Roof Renovation": 4,
  "Shading Device Installation": 5,
  "Wall Insulation": 6,
  "Window Upgrade": 7,
  "Air Distribution System": 8,
  "Cooling System Retrofit": 9,
  "Energy Recovery": 10,
  "Heating System Retrofit": 11,
  "Pump System Upgrade": 12,
  "Day-lighting Control": 13,
  "Lighting Fixture Replacement": 14,
  "Occupancy Sensor Installation": 15,
  "Heater Replacement": 16,
  "Photovoltaic system": 17,
    "Hot Water Point of Use": 18,
    "Indoor Exit Lighting": 19,
    "Indoor General Lighting": 20,
    "Indoor Retail Display Lighting": 21,
    "Indoor Task Lighting": 22,
    "Kitchen Appliances": 23,
    "Landscape Irrigation": 24,
    "Laundry Appliances": 25,
    "Manufacturing - Average quality air": 26,
    "Manufacturing - Dry air": 27,
    "Material conveying/packaging": 28,
    "Metal/material melting": 29,
    "Office Equipment": 30,
    "Opaque Envelope": 31,
    "Outdoor Common Area Lighting": 32,
    "Outdoor General Lighting": 33,
    "Outdoor Parking Garage Lighting": 34,
    "Outdoor Parking Lot Lighting": 35,
    "Outdoor Signage": 36,
    Pasteurizing: 37,
    "Pneumatic controls operation": 38,
    Pool: 39,
    "Preheating of liquids/solids": 40,
    "Product chilling": 41,
    "Product manufacturing": 42,
    "Product storage": 43,
    "Product Vending": 44,
    Pumping: 45,
    "Refrigerated Display": 46,
    "Refrigerated Storage": 47,
    "Refrigeration Display Case Lighting": 48,
    "Refrigeration Equipment": 49,
    Reheat: 50,
    "Retro-Commissioning Services": 51,
    "Seasonal Lighting": 52,
    Separation: 53,
    Spa: 54,
    "Space Cooling": 55,
    "Space Heating": 56,
    "Space Heating and Cooling": 57,
    "Steam Distribution": 58,
    "Tools operation": 59,
    "Ventilation and Air Distribution": 60,
    "Water Distribution": 61,
    "Water Heating": 62

};

const invertMap = (obj) => {
  const result = {};
  Object.entries(obj).forEach(([label, id]) => {
    result[id] = label.trim();
  });
  return result;
};

const normalize = (value) => String(value).trim().toLowerCase();

const toCanonicalLabelMap = (obj) => {
  const result = {};
  Object.keys(obj).forEach((label) => {
    result[normalize(label)] = label.trim();
  });
  return result;
};

const deerCategoriesById = invertMap(deerCategories);
const deerSubCategoriesById = invertMap(deerSubCategories);
const deerCategoriesByLabel = toCanonicalLabelMap(deerCategories);
const deerSubCategoriesByLabel = toCanonicalLabelMap(deerSubCategories);

const resolveLabel = (value, byId, byLabel) => {
  if (value === undefined || value === null) return "";

  const asString = String(value).trim();
  if (!asString) return "";

  const asNumber = Number(asString);
  if (Number.isInteger(asNumber) && byId[asNumber]) {
    return byId[asNumber];
  }

  const normalized = normalize(asString);
  if (byLabel[normalized]) {
    return byLabel[normalized];
  }

  return asString;
};

export const resolveDeerCategory = (value) =>
  resolveLabel(value, deerCategoriesById, deerCategoriesByLabel);

export const resolveDeerSubCategory = (value) =>
  resolveLabel(value, deerSubCategoriesById, deerSubCategoriesByLabel);

export const buildDeerMeta = (categoryValue, subCategoryValue) => {
  const category = resolveDeerCategory(categoryValue);
  const subCategory = resolveDeerSubCategory(subCategoryValue);

  const categoryLabel = category ? `Category: ${category}` : "";
  const subCategoryLabel = subCategory ? `Subcategory: ${subCategory}` : "";
  const barMeta = [categoryLabel, subCategoryLabel].filter(Boolean).join(" • ");

  return { category, subCategory, categoryLabel, subCategoryLabel, barMeta };
};

export { deerCategories, deerSubCategories };
